import React, { useState, Children } from 'react';
import { useFormContext } from 'react-hook-form';
import { PlusIcon, TrashIcon, UploadIcon } from 'lucide-react';
const SpouseAndFamily = () => {
  const {
    register,
    formState: {
      errors
    },
    watch
  } = useFormContext();
  const [children, setChildren] = useState([{
    id: 1,
    name: '',
    age: ''
  }]);
  const [grandchildren, setGrandchildren] = useState([{
    id: 1,
    name: '',
    age: '',
    parent: ''
  }]);
  const maritalStatus = watch('clientInfo.maritalStatus');
  const addChild = () => {
    const newId = children.length > 0 ? Math.max(...children.map(c => c.id)) + 1 : 1;
    setChildren([...children, {
      id: newId,
      name: '',
      age: ''
    }]);
  };
  const removeChild = (id: number) => {
    setChildren(children.filter(child => child.id !== id));
  };
  const addGrandchild = () => {
    const newId = grandchildren.length > 0 ? Math.max(...grandchildren.map(g => g.id)) + 1 : 1;
    setGrandchildren([...grandchildren, {
      id: newId,
      name: '',
      age: '',
      parent: ''
    }]);
  };
  const removeGrandchild = (id: number) => {
    setGrandchildren(grandchildren.filter(grandchild => grandchild.id !== id));
  };
  return <div className="space-y-8" data-id="element-952">
      <div className="bg-slate-50 p-4 rounded-lg border border-slate-200 mb-6" data-id="element-953">
        <p className="text-slate-700" data-id="element-954">
          Please provide information about your spouse, children, and other
          family members.
        </p>
      </div>

      {/* Spouse Information */}
      {(maritalStatus === 'married' || maritalStatus === 'commonLaw') && <div className="space-y-6" data-id="element-955">
          <h3 className="text-lg font-medium text-navy-900 border-b border-slate-200 pb-2" data-id="element-956">
            Spouse Information
          </h3>

          <div data-id="element-957">
            <label className="block text-navy-800 font-medium mb-2" data-id="element-958">
              Spouse's Name
              <span className="text-red-500 ml-1" data-id="element-959">*</span>
            </label>
            <input type="text" className="w-full px-3 py-2 border border-slate-300 rounded-md focus:outline-none focus:ring-2 focus:ring-navy-500" placeholder="Enter your spouse's full legal name" {...register('spouseInfo.name')} data-id="element-960" />
          </div>

          <div data-id="element-961">
            <label className="block text-navy-800 font-medium mb-2" data-id="element-962">
              Spouse's Age
            </label>
            <input type="number" className="w-full px-3 py-2 border border-slate-300 rounded-md focus:outline-none focus:ring-2 focus:ring-navy-500" placeholder="Enter your spouse's age" {...register('spouseInfo.age')} data-id="element-963" />
          </div>
        </div>}

      {/* Previous Marriages */}
      <div className="space-y-4" data-id="element-964">
        <h3 className="text-lg font-medium text-navy-900 border-b border-slate-200 pb-2" data-id="element-965">
          Previous Marriages
        </h3>

        <div data-id="element-966">
          <label className="block text-navy-800 font-medium mb-2" data-id="element-967">
            Have you been previously married?
          </label>
          <div className="flex items-center space-x-4 mb-4" data-id="element-968">
            <label className="inline-flex items-center" data-id="element-969">
              <input type="radio" className="form-radio h-5 w-5 text-navy-600" value="true" {...register('previousMarriages.exists')} data-id="element-970" />
              <span className="ml-2" data-id="element-971">Yes</span>
            </label>
            <label className="inline-flex items-center" data-id="element-972">
              <input type="radio" className="form-radio h-5 w-5 text-navy-600" value="false" {...register('previousMarriages.exists')} data-id="element-973" />
              <span className="ml-2" data-id="element-974">No</span>
            </label>
          </div>

          {watch('previousMarriages.exists') === 'true' && <div data-id="element-975">
              <label className="block text-navy-800 font-medium mb-2" data-id="element-976">
                Name of ex-spouse
              </label>
              <input type="text" className="w-full px-3 py-2 border border-slate-300 rounded-md focus:outline-none focus:ring-2 focus:ring-navy-500" placeholder="Enter name of ex-spouse" {...register('previousMarriages.exSpouseName')} data-id="element-977" />
            </div>}
        </div>
      </div>

      {/* Domestic Contracts */}
      <div className="space-y-4" data-id="element-978">
        <h3 className="text-lg font-medium text-navy-900 border-b border-slate-200 pb-2" data-id="element-979">
          Domestic Contracts
        </h3>

        <div data-id="element-980">
          <label className="block text-navy-800 font-medium mb-2" data-id="element-981">
            Do you have any domestic contracts? (e.g., prenuptial agreement,
            separation agreement)
          </label>
          <div className="flex items-center space-x-4 mb-4" data-id="element-982">
            <label className="inline-flex items-center" data-id="element-983">
              <input type="radio" className="form-radio h-5 w-5 text-navy-600" value="true" {...register('domesticContracts.exists')} data-id="element-984" />
              <span className="ml-2" data-id="element-985">Yes</span>
            </label>
            <label className="inline-flex items-center" data-id="element-986">
              <input type="radio" className="form-radio h-5 w-5 text-navy-600" value="false" {...register('domesticContracts.exists')} data-id="element-987" />
              <span className="ml-2" data-id="element-988">No</span>
            </label>
          </div>

          {watch('domesticContracts.exists') === 'true' && <div data-id="element-989">
              <label className="block text-navy-800 font-medium mb-2" data-id="element-990">
                Upload domestic contract (optional)
              </label>
              <div className="border-2 border-dashed border-slate-300 rounded-md p-4 text-center" data-id="element-991">
                <UploadIcon className="mx-auto h-12 w-12 text-slate-400" data-id="element-992" />
                <p className="mt-2 text-sm text-slate-600" data-id="element-993">
                  Drag and drop your file here, or click to select
                </p>
                <input type="file" className="hidden" id="domestic-contract-upload" {...register('domesticContracts.file')} data-id="element-994" />
                <button type="button" onClick={() => document.getElementById('domestic-contract-upload')?.click()} className="mt-2 px-4 py-2 bg-navy-700 text-white text-sm rounded-md hover:bg-navy-800" data-id="element-995">
                  Select File
                </button>
              </div>
            </div>}
        </div>
      </div>

      {/* Support Obligations */}
      <div className="space-y-4" data-id="element-996">
        <h3 className="text-lg font-medium text-navy-900 border-b border-slate-200 pb-2" data-id="element-997">
          Support Obligations
        </h3>

        <div data-id="element-998">
          <label className="block text-navy-800 font-medium mb-2" data-id="element-999">
            Do you have any support obligations? (e.g., child support, spousal
            support)
          </label>
          <div className="flex items-center space-x-4 mb-4" data-id="element-1000">
            <label className="inline-flex items-center" data-id="element-1001">
              <input type="radio" className="form-radio h-5 w-5 text-navy-600" value="true" {...register('supportObligations.exists')} data-id="element-1002" />
              <span className="ml-2" data-id="element-1003">Yes</span>
            </label>
            <label className="inline-flex items-center" data-id="element-1004">
              <input type="radio" className="form-radio h-5 w-5 text-navy-600" value="false" {...register('supportObligations.exists')} data-id="element-1005" />
              <span className="ml-2" data-id="element-1006">No</span>
            </label>
          </div>

          {watch('supportObligations.exists') === 'true' && <div data-id="element-1007">
              <label className="block text-navy-800 font-medium mb-2" data-id="element-1008">
                Details of support obligations
              </label>
              <textarea className="w-full px-3 py-2 border border-slate-300 rounded-md focus:outline-none focus:ring-2 focus:ring-navy-500" rows={3} placeholder="Enter details of your support obligations" {...register('supportObligations.details')} data-id="element-1009" />
            </div>}
        </div>
      </div>

      {/* Children */}
      <div className="space-y-4" data-id="element-1010">
        <div className="flex justify-between items-center" data-id="element-1011">
          <h3 className="text-lg font-medium text-navy-900 border-b border-slate-200 pb-2" data-id="element-1012">
            Children
          </h3>
          <button type="button" onClick={addChild} className="flex items-center text-sm text-navy-700 hover:text-navy-900" data-id="element-1013">
            <PlusIcon size={16} className="mr-1" data-id="element-1014" />
            Add Child
          </button>
        </div>

        {children.map((child, index) => <div key={child.id} className="p-4 bg-slate-50 rounded-md" data-id="element-1015">
            <div className="flex justify-between items-center mb-3" data-id="element-1016">
              <h4 className="font-medium" data-id="element-1017">Child {index + 1}</h4>
              {children.length > 1 && <button type="button" onClick={() => removeChild(child.id)} className="text-red-500 hover:text-red-700" data-id="element-1018">
                  <TrashIcon size={16} data-id="element-1019" />
                </button>}
            </div>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-1020">
              <div data-id="element-1021">
                <label className="block text-navy-800 font-medium mb-2" data-id="element-1022">
                  Name
                </label>
                <input type="text" className="w-full px-3 py-2 border border-slate-300 rounded-md focus:outline-none focus:ring-2 focus:ring-navy-500" placeholder="Enter child's name" {...register(`children.${index}.name`)} data-id="element-1023" />
              </div>
              <div data-id="element-1024">
                <label className="block text-navy-800 font-medium mb-2" data-id="element-1025">
                  Age
                </label>
                <input type="number" className="w-full px-3 py-2 border border-slate-300 rounded-md focus:outline-none focus:ring-2 focus:ring-navy-500" placeholder="Enter child's age" {...register(`children.${index}.age`)} data-id="element-1026" />
              </div>
            </div>
          </div>)}

        {/* Note about treating others like children */}
        <div className="bg-amber-50 p-4 rounded-md border border-amber-200" data-id="element-1027">
          <p className="text-sm text-amber-800" data-id="element-1028">
            <strong data-id="element-1029">Note:</strong> If there are any others that you treat like a
            child and want to be included in this category, please specifically
            advise in the text box below.
          </p>
        </div>
        <div data-id="element-1030">
          <label className="block text-navy-800 font-medium mb-2" data-id="element-1031">
            Additional persons treated as children
          </label>
          <textarea className="w-full px-3 py-2 border border-slate-300 rounded-md focus:outline-none focus:ring-2 focus:ring-navy-500" rows={3} placeholder="Please list any other persons you treat like a child and wish to include" {...register('additionalChildLikePersons')} data-id="element-1032" />
        </div>
      </div>

      {/* Grandchildren */}
      <div className="space-y-4" data-id="element-1033">
        <div className="flex justify-between items-center" data-id="element-1034">
          <h3 className="text-lg font-medium text-navy-900 border-b border-slate-200 pb-2" data-id="element-1035">
            Grandchildren
          </h3>
          <button type="button" onClick={addGrandchild} className="flex items-center text-sm text-navy-700 hover:text-navy-900" data-id="element-1036">
            <PlusIcon size={16} className="mr-1" data-id="element-1037" />
            Add Grandchild
          </button>
        </div>

        {grandchildren.map((grandchild, index) => <div key={grandchild.id} className="p-4 bg-slate-50 rounded-md" data-id="element-1038">
            <div className="flex justify-between items-center mb-3" data-id="element-1039">
              <h4 className="font-medium" data-id="element-1040">Grandchild {index + 1}</h4>
              {grandchildren.length > 1 && <button type="button" onClick={() => removeGrandchild(grandchild.id)} className="text-red-500 hover:text-red-700" data-id="element-1041">
                  <TrashIcon size={16} data-id="element-1042" />
                </button>}
            </div>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-4" data-id="element-1043">
              <div data-id="element-1044">
                <label className="block text-navy-800 font-medium mb-2" data-id="element-1045">
                  Name
                </label>
                <input type="text" className="w-full px-3 py-2 border border-slate-300 rounded-md focus:outline-none focus:ring-2 focus:ring-navy-500" placeholder="Enter grandchild's name" {...register(`grandchildren.${index}.name`)} data-id="element-1046" />
              </div>
              <div data-id="element-1047">
                <label className="block text-navy-800 font-medium mb-2" data-id="element-1048">
                  Age
                </label>
                <input type="number" className="w-full px-3 py-2 border border-slate-300 rounded-md focus:outline-none focus:ring-2 focus:ring-navy-500" placeholder="Enter grandchild's age" {...register(`grandchildren.${index}.age`)} data-id="element-1049" />
              </div>
              <div data-id="element-1050">
                <label className="block text-navy-800 font-medium mb-2" data-id="element-1051">
                  Parent (Your Child)
                </label>
                <select className="w-full px-3 py-2 border border-slate-300 rounded-md focus:outline-none focus:ring-2 focus:ring-navy-500" {...register(`grandchildren.${index}.parent`)} data-id="element-1052">
                  <option value="" data-id="element-1053">Select parent</option>
                  {children.map(child => <option key={child.id} value={child.id} data-id="element-1054">
                      {watch(`children.${children.findIndex(c => c.id === child.id)}.name`) || `Child ${child.id}`}
                    </option>)}
                </select>
              </div>
            </div>
          </div>)}
      </div>

      {/* Deceased Children */}
      <div className="space-y-4" data-id="element-1055">
        <h3 className="text-lg font-medium text-navy-900 border-b border-slate-200 pb-2" data-id="element-1056">
          Deceased Children
        </h3>

        <div data-id="element-1057">
          <label className="block text-navy-800 font-medium mb-2" data-id="element-1058">
            Do you have any deceased children?
          </label>
          <div className="flex items-center space-x-4 mb-4" data-id="element-1059">
            <label className="inline-flex items-center" data-id="element-1060">
              <input type="radio" className="form-radio h-5 w-5 text-navy-600" value="true" {...register('deceasedChildren.exists')} data-id="element-1061" />
              <span className="ml-2" data-id="element-1062">Yes</span>
            </label>
            <label className="inline-flex items-center" data-id="element-1063">
              <input type="radio" className="form-radio h-5 w-5 text-navy-600" value="false" {...register('deceasedChildren.exists')} data-id="element-1064" />
              <span className="ml-2" data-id="element-1065">No</span>
            </label>
          </div>

          {watch('deceasedChildren.exists') === 'true' && <div data-id="element-1066">
              <label className="block text-navy-800 font-medium mb-2" data-id="element-1067">
                Names of deceased children
              </label>
              <textarea className="w-full px-3 py-2 border border-slate-300 rounded-md focus:outline-none focus:ring-2 focus:ring-navy-500" rows={3} placeholder="Enter names of deceased children" {...register('deceasedChildren.names')} data-id="element-1068" />
            </div>}
        </div>
      </div>
    </div>;
};
export default SpouseAndFamily;